<form [formGroup]="dataprotectionForm">
    <section-info [overrideTitle]="dataprotectionTitle ?? 'dataprotection.title' | translate"></section-info>
    <div>
        <div [trimRichtextAriaLabel]="dataprotectionText ?? ''" [innerHTMLBypassXSS]="dataprotectionText ?? ''"></div>
    </div>
    <kendo-formfield class="dsgvoAccepted">
        <span class="k-checkbox-list-item">
            <div class="k-checkbox-wrap">
                <input id="checkbox" #datenschutz type="checkbox" kendoCheckBox formControlName="dsgvoAccepted" />
            </div>
            <label for="checkbox" class="k-checkbox-label ml-2">
                <div [trimRichtextAriaLabel]="dataprotectionInfoText ?? 'dataprotection.infoText' | translate" [innerHTMLBypassXSS]="dataprotectionInfoText ?? 'dataprotection.infoText' | translate"></div>
            </label>
        </span>
        <kendo-formerror *ngFor="let errorMessage of datenschutzErrorMessages" [title]="errorMessage">{{errorMessage}}</kendo-formerror>
    </kendo-formfield>
</form>
